// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-grid .buttons-group {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
ion-grid .buttons-group ion-button {
  position: relative !important;
  right: 0 !important;
  left: 0 !important;
}
ion-grid img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}`, "",{"version":3,"sources":["webpack://./src/app/popovers/popover-marketing/popover-marketing.component.scss"],"names":[],"mappings":"AACI;EACI,WAAA;EACA,aAAA;EACA,8BAAA;AAAR;AAEQ;EACI,6BAAA;EACA,mBAAA;EACA,kBAAA;AAAZ;AAII;EACI,WAAA;EACA,YAAA;EACA,iBAAA;AAFR","sourcesContent":["ion-grid {\r\n    .buttons-group {\r\n        width: 100%;\r\n        display: flex;\r\n        justify-content: space-between;\r\n\r\n        ion-button {\r\n            position: relative !important;\r\n            right: 0 !important;\r\n            left: 0 !important;\r\n        }\r\n    }\r\n\r\n    img {\r\n        width: 100%;\r\n        height: 100%;\r\n        object-fit: cover;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
